/**
 * Il banco dell'operatore: da qui in poi e' il Cockpit.
 *
 * **Perche' questo file resta.** Non per compatibilita': perche' l'instradamento
 * ha un nome suo per «la schermata dove si decide», e il Cockpit e' cio' che
 * quel nome contiene oggi. Se la route puntasse direttamente al Cockpit, il
 * giorno in cui il banco diventa un'altra cosa — e la composizione e' cambiata
 * due volte in un anno — l'instradamento andrebbe riscritto insieme alla
 * schermata. Un adattatore di due righe costa meno di quella coppia.
 *
 * **Cio' che c'era prima era una composizione di passaggio.** Tre colonne di
 * pari dignita': contesto a sinistra, coda a sinistra, verdetto a destra, e il
 * fotogramma in mezzo a dividersi la larghezza in tre. La direzione approvata
 * mette il visualizzatore al centro come ancora e tutto il resto attorno; la
 * composizione vecchia non si poteva stringere fino a diventare quella, e non
 * l'abbiamo stretta — e' stata sostituita.
 */
import { Cockpit, type FrameRef } from './cockpit/Cockpit'
import type { Candidate } from './types'

export interface DeskProps {
  inspectionId: string
  conflictId?: string | null
  /* La sessione con cui il pool ha riservato questi candidati. Senza, il
   * servizio risponde come a chi non ha preso niente: i propri lease gli
   * risultano di un altro, e la coda si apre vuota su lavoro gia' in mano. */
  reviewSessionId?: string | null
  /** Il candidato che l'indirizzo nomina, per identita' e non per posizione. */
  candidateId?: string | null
  /** Dove il banco dice all'indirizzo su quale candidato si e' spostato. */
  onCandidate?: (detectionId: string | null) => void
  /** L'uscita verso la ricerca libera, quando l'instradamento ce l'ha, col
   *  fotogramma che si aveva davanti (GI-265). */
  onManualFinding?: (frame?: FrameRef) => void
  /** L'uscita verso la scheda dell'elemento, quando l'instradamento ce l'ha. */
  onElement?: (candidate: Candidate) => void
  /** La sessione aperta sul posto, da mettere nell'indirizzo (GI-246). */
  onSession?: (reviewSessionId: string) => void
  /** L'uscita verso gli altri fotogrammi dell'elemento (GI-248). */
  onElementFrames?: (candidate: Candidate) => void
  /** Chi lavora: per la memoria dei primi verdetti (GI-281). */
  login?: string | null
}

export function Desk({
  inspectionId,
  login = null,
  conflictId = null,
  reviewSessionId = null,
  candidateId = null,
  onCandidate,
  onManualFinding,
  onElement,
  onSession,
  onElementFrames,
}: DeskProps): JSX.Element {
  return (
    <Cockpit
      inspectionId={inspectionId}
      login={login}
      conflictId={conflictId}
      reviewSessionId={reviewSessionId}
      candidateId={candidateId}
      onCandidate={onCandidate}
      onManualFinding={onManualFinding}
      onElement={onElement}
      onSession={onSession}
      onElementFrames={onElementFrames}
    />
  )
}
